import { render, staticRenderFns } from "./PlaceTravel.vue?vue&type=template&id=c029d0ee&scoped=true&"
import script from "./PlaceTravel.vue?vue&type=script&lang=js&"
export * from "./PlaceTravel.vue?vue&type=script&lang=js&"
import style0 from "./PlaceTravel.vue?vue&type=style&index=0&id=c029d0ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c029d0ee",
  null
  
)

export default component.exports